import _isEmpty from "lodash/isEmpty"
export const getSessionIdObjWithEpoc = () => {
  const cookies = document.cookie.split(";") ?? []
  let sessionCookie =
    cookies.find(myCookie => myCookie.includes("session#")) ?? ""
  sessionCookie =
    sessionCookie.split("|").find(item => item.includes("session")) ?? ""
  const sessionCookies = sessionCookie.split("#") ?? []
  const sessionId = sessionCookies[1] ?? ""
  return sessionId ? `${sessionId}-${Date.now()}` : ""
}

export const getIsPreviewModeFlag = () => {
  const cookies = document.cookie.split(";") ?? []
  const preViewModeCookie =
    cookies.find(myCookie => myCookie.includes("aem-author-preview-mode")) ?? ""

  return !_isEmpty(preViewModeCookie)
}
